import { render, staticRenderFns } from "./inicial.vue?vue&type=template&id=0300f274&scoped=true&"
import script from "./inicial.vue?vue&type=script&lang=js&"
export * from "./inicial.vue?vue&type=script&lang=js&"
import style0 from "./inicial.vue?vue&type=style&index=0&id=0300f274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300f274",
  null
  
)

export default component.exports